import { render, staticRenderFns } from "./ArticleOtherLinks.vue?vue&type=template&id=1a9ab46a&scoped=true&"
import script from "./ArticleOtherLinks.vue?vue&type=script&lang=js&"
export * from "./ArticleOtherLinks.vue?vue&type=script&lang=js&"
import style0 from "./ArticleOtherLinks.vue?vue&type=style&index=0&id=1a9ab46a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9ab46a",
  null
  
)

export default component.exports